// Centralized data-testid registry for Trendy Closet site
export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const NAV = {
  root: 'site-nav',
  logo: 'site-logo',
  link: (slug) => `nav-link-${slug}`,
  cta: 'nav-cta-book',
  mobileToggle: 'nav-mobile-toggle',
  mobileMenu: 'nav-mobile-menu',
};

export const HERO = {
  root: 'hero-section',
  shopBtn: 'hero-shop-btn',
  bookBtn: 'hero-book-btn',
};

export const COLLECTIONS = {
  root: 'collections-section',
  card: (slug) => `collection-card-${slug}`,
};

export const WHYUS = {
  root: 'why-us-section',
  card: (slug) => `whyus-card-${slug}`,
};

export const ABOUT = { root: 'about-section' };

export const TESTI = {
  root: 'testimonials-section',
  prev: 'testimonials-prev',
  next: 'testimonials-next',
  dot: (i) => `testimonials-dot-${i}`,
};

export const GALLERY = {
  root: 'gallery-section',
  tile: (slug) => `gallery-tile-${slug}`,
};

export const RENTALS = { root: 'rentals-section', cta: 'rentals-cta' };

export const APPT = {
  root: 'appointment-section',
  form: 'appointment-form',
  name: 'appt-name',
  phone: 'appt-phone',
  email: 'appt-email',
  date: 'appt-date',
  occasion: 'appt-occasion',
  message: 'appt-message',
  submit: 'appt-submit',
  success: 'appt-success',
};

export const CONTACT = {
  root: 'contact-section',
  call: 'contact-call-btn',
  directions: 'contact-directions-btn',
  map: 'contact-map',
};

export const FAQ = {
  root: 'faq-section',
  item: (i) => `faq-item-${i}`,
};

export const NEWS = {
  root: 'newsletter-section',
  email: 'newsletter-email',
  submit: 'newsletter-submit',
};

export const FOOTER = { root: 'site-footer' };

export const FLOAT = {
  whatsapp: 'float-whatsapp',
  call: 'float-call',
  top: 'float-top',
};
